import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'gwx-voyager-components';
import SubscriptionListContainer from './List/SubscriptionList.react';
import SubscriptionForm from './Form/SubscriptionForm.react';

/**
 * Containing component that presents the various Subscriptions components
 * and their respective subroutes.
 */
const Subscriptions = ({ match }) => (
	<div>		
		<Switch>
			<Route exact path={match.path} />
			<Route exact path={`${match.path}/add`} component={SubscriptionForm} />
			<Redirect to='/pageNotFound' />
		</Switch>
		<SubscriptionListContainer />
	</div>
);
Subscriptions.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

export default Subscriptions;
